<script>
	import Icon from './Icon.svelte';
	export let icon = 'inline_default';
	export let background = 'none';
	export let message = '';
	export let centered = false;
</script>

<div
	class="inline-notification"
	class:info={background == 'info'}
	class:warning={background == 'warning'}
	class:danger={background == 'danger'}
	class:centered
>
	<Icon name={icon} />
	<p>{message}</p>
	<slot />
</div>

<style>
	div {
		width: 100%;
		display: flex;
		border-radius: 6px;
		align-items: center;
		padding: 0.5em;
	}
	p {
		margin: unset;
		margin-left: 8px;
		font-size: 0.9rem;
	}
	.inline-notification.info {
		background-color: #f0f8ff;
		color: #091eb5;
	}

	.inline-notification.warning {
		background-color: #fffbf0;
		color: #8f6f04;
	}
	.inline-notification.danger {
		background-color: #fff2f0;
		color: #951800;
	}
	.inline-notification.centered {
		justify-content: center;
	}
</style>
